import React from 'react'
import Spinner from 'react-bootstrap/Spinner'
import {Container} from 'react-bootstrap'

export const CatoroSpinner = () => (
        <>
          <Container>
              <Spinner animation="grow" variant="success" size="sm" />
              <Spinner animation="grow" variant="danger" />
              <Spinner animation="grow" variant="warning"  />
              <br></br>
              <i>Getting everything ready. Please wait.</i>
          </Container>
        </>
);